import { Vue, Component, Watch, Prop, Inject } from 'vue-property-decorator';
import style from './style.vue';
import { EmpServiceAPIActions } from '@/services/empService';
import { appEnvConfig } from '@/configs/appConfigs';
import baseAPIService from '@/services/base/baseAPIService';
import LinkForm from '@/views/components/linkForm/linkForm.vue';
import { defaultImg } from '@/views/components/newDisplayConfig/shop';
import { IPSService } from '@/services/ipsServices';
import { QinggerLibUtils } from '@/util';
import { ZhanKai, ShouQi } from '@/views/components/newDisplayConfig/appHoverIcon';
import { Functions } from '@/library/utils/functions';
const isset = QinggerLibUtils.isset;

interface HoverIconInfo {
  siteId?: number;
  showType?: 7;
  ygswpId?: number;
  fieldType?: string;
  desc?: HoverIconDesc;
}

interface HoverIconDesc {
  isEnable?: number;
  showBeforeIcon?: string;
  showAfterIcon?: string;
  list?: HoverIconLinkList[];
}

interface HoverIconLinkList {
  iconImage?: string;
  iconName?: string;
  linkType?: number;
  linkId?: number;
  couponInfo?: { cplId?: string; couponCover?: string; points?: number };
  jumpPath?: { appName?: string; pagePath?: string };
  hotPosition?: { x?: number; y?: number; height?: number; width?: number; yPercent?: number; hPercent?: number; xPercent?: number; wPercent?: number };
  officialAccount?: {
    accountTitle?: string;
    accountUrl?: string;
  };
  linkDesc?: string;
  isAloneConfig: 0 | 1; // 是否单独展示0不展示、1展示
  showlocation?: number[];
  actType?: string;
  productSort?: number;
  shareImage?: string;
  shareInfo?: string;
}

const PositionList = ['HOT', '店铺', '活动', '分类', '购物车', '我的', '商品详情', '报名活动', '发售', '商品列表'];
@Component({
  components: { LinkForm },
  mixins: [style],
})
export default class AppHoverIcon extends Vue {
  @Prop()
    value: HoverIconInfo;

  @Inject()
    openCoupon: Function;

  @Watch('value', { immediate: true, deep: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  data: HoverIconInfo = {};

  imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  goodsClassList = [];

  attributeList = [];

  async mounted() {
    this.goodsClassList = await this.getGoodsClassList();
    this.attributeList = await this.getAttributeList();
  }

  /**
   * 获取关联分类
   */
  public getAttributeList(): Promise<any> {
    return IPSService.getAttributeList().then((res) => {
      return isset(res, 'list') ? res.list : [];
    });
  }

  getGoodsClassList() {
    return IPSService.siteClassList({
      postParams: {
        siteId: +this.$route.params.siteId,
      },
    }).then((response) => {
      return isset(response, 'list') ? response.list : [];
    });
  }

  beforeUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt1000KB = file.size / 1024 < 300;

    if (!isJPG && !isPNG && !isGIF) {
      this.$message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt1000KB) {
      this.$message.error(`上传图片大小不能超过 ${300}KB!`);
    }
    return (isJPG || isPNG || isGIF) && isLt1000KB;
  }

  uploadSuccess(res: HttpAPIRetItem<any>, i) {
    switch (i) {
      case -1:
        this.data.desc.showBeforeIcon = res.content;
        break;
      case -2:
        this.data.desc.showAfterIcon = res.content;
        break;

      default:
        this.data.desc.list[i].iconImage = res.content;
        break;
    }
  }

  onLinkChange(val, i) {
    this.data.desc.list[i].couponInfo = val.couponInfo;
    this.data.desc.list[i].linkDesc = val.linkDesc;
    this.data.desc.list[i].linkType = val.linkType;
    this.data.desc.list[i].linkId = val.linkId;
    this.data.desc.list[i].officialAccount = val.officialAccount;
    this.data.desc.list[i].jumpPath = val.jumpPath;
    this.data.desc.list[i].hotPosition = val.hotPosition;
    this.data.desc.list[i].productSort = val.productSort;
    this.data.desc.list[i].shareImage = val.shareImage;
    this.data.desc.list[i].shareInfo = val.shareInfo;
    this.data.desc.list[i].actType = val.actType || '';
  }

  addIconClick() {
    this.data.desc.list.push({
      iconImage: '',
      iconName: '',
      isAloneConfig: 0,
      showlocation: [],
    });
  }

  handleDel(index) {
    this.$confirm('确认删除?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.data.desc.list.splice(index, 1);
      }
    });
  }

  // 重置图标
  resetIcon() {
    this.$confirm('确认重置展开、收起图标为默认图标?', { type: 'warning' }).then((result) => {
      if (result === 'confirm') {
        this.data.desc.showBeforeIcon = ShouQi;
        this.data.desc.showAfterIcon = ZhanKai;
      }
    });
  }

  renderIconConfig(h, i) {
    return (
      <div class="icon-item-config">
        <i class="el-icon-error delete" onClick={this.handleDel.bind(this, i)} />
        <el-form-item class="icon-upload" prop={`list[${i}].iconImage`} rules={{ required: true, message: ' ', trigger: 'change' }}>
          <img src={this.data.desc.list[i].iconImage || defaultImg} class="img" />
          <el-upload
            action={this.imgTpConfig}
            headers={this.tokenData}
            before-upload={this.beforeUpload}
            maxSize={300}
            data={{ corpId: baseAPIService.resolveCorpId() }}
            {...{
              props: {
                'on-success': val => this.uploadSuccess(val, i),
                'on-error': () => {
                  this.$message.error('图片上传错误，请稍后重试！');
                },
              },
            }}
            show-file-list={false}>
            <span class="modify">修改</span>
          </el-upload>
        </el-form-item>

        <el-form-item class="r-pr-16" label="图标名称">
          <el-input v-model={this.data.desc.list[i].iconName} />
        </el-form-item>
        <LinkForm
          attributeList={this.attributeList.map((v) => {
            v.value_name = v.attrName;
            v.value_no = v.attrCode;
            v.class_code = v.attrCode;
            v.isLeafe = !v.list || !v.list.length;
            return v;
          })}
          empCode={this.$store.state.empCode}
          state={1}
          sgId={+this.$route.params.sgId}
          siteCodes={[this.$route.params.code]}
          siteId={+this.$route.params.siteId}
          onChange={val => this.onLinkChange(val, i)}
          ref="linkForm"
          class="icon-link r-pr-16"
          mode={2}
          hotAd={false}
          sortShow={true}
          dialogFooter={false}
          goodsClassList={this.goodsClassList}
          value={this.data.desc.list[i]}
          onInput={val => this.onLinkChange(val, i)}
          exclude={this.openCoupon() ? [7, 8, 22] : [7, 8, 12, 22]}
        />
        <el-form-item label="展示配置" class="r-pr-16">
          <el-checkbox class="hei-16" v-model={this.data.desc.list[i].isAloneConfig} true-label={1} false-label={0}>
            单独展示
          </el-checkbox>
          <p class="tip line-height-16">勾选单独展示后,页面存在多个图标时该图标不参与收起</p>
        </el-form-item>
        <el-form-item label="展示位置" class="icon-position">
          <el-checkbox-group v-model={this.data.desc.list[i].showlocation}>
            {PositionList.map((val, index) => {
              return (
                <el-checkbox label={index + 1} key={index}>
                  {val}
                </el-checkbox>
              );
            })}
          </el-checkbox-group>
        </el-form-item>
      </div>
    );
  }

  render(h) {
    return (
      <div class="icon-config">
        <div class="icon-display-config">
          <div class="title">
            <span>
              <span class="font-bold font-size-14">展开配置</span>
            </span>
            <p class="tip">
              <span class="redText">*&nbsp;</span>&nbsp;当悬浮图标包含两个及以上时,支持通过收起和展开的方式展示
            </p>
          </div>
          <el-checkbox true-label={1} false-label={0} v-model={this.data.desc.isEnable} class="inline-block r-pt-8 r-pb-12 r-px-0">
            启用
          </el-checkbox>
          <span class="scopeSpan font-size-14" onClick={this.resetIcon.bind(this)}>
            重置
          </span>
          <div class="icon-open-close">
            <div class="title">图标</div>
            <div class="icon-upload">
              <img src={this.data.desc.showAfterIcon} class="img" />
              <el-upload
                action={this.imgTpConfig}
                headers={this.tokenData}
                before-upload={this.beforeUpload}
                maxSize={300}
                data={{ corpId: baseAPIService.resolveCorpId() }}
                {...{
                  props: {
                    'on-success': val => this.uploadSuccess(val, -2),
                    'on-error': () => {
                      this.$message.error('图片上传错误，请稍后重试！');
                    },
                  },
                }}
                show-file-list={false}>
                <span class="modify">修改</span>
              </el-upload>
              <p class="icon-desc">展开前</p>
            </div>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <div class="icon-upload">
              <img src={this.data.desc.showBeforeIcon} class="img" />
              <el-upload
                action={this.imgTpConfig}
                headers={this.tokenData}
                before-upload={this.beforeUpload}
                maxSize={300}
                data={{ corpId: baseAPIService.resolveCorpId() }}
                {...{
                  props: {
                    'on-success': val => this.uploadSuccess(val, -1),
                    'on-error': () => {
                      this.$message.error('图片上传错误，请稍后重试！');
                    },
                  },
                }}
                show-file-list={false}>
                <span class="modify">修改</span>
              </el-upload>
              <p class="icon-desc">展开后</p>
            </div>
          </div>
        </div>
        <el-form label-width="80px" props={{ model: this.data.desc }} label-position="left" ref="iconListForm">
          {this.data.desc.list.map((v, i) => {
            return this.renderIconConfig(h, i);
          })}
        </el-form>
        {this.data.desc.list.length < 6 && (
          <div class="scopeSpan add-icon" onClick={this.addIconClick.bind(this)}>
            +添加一个悬浮图标
          </div>
        )}
        <p class="tip blockTip">注：建议图片分辨率为150px*150px，大小不超过300k，支持jpg、gif、png格式</p>
      </div>
    );
  }
}
